
import React from 'react'

import PowerpackItem from '../Components/PowerpackItem';

class PowerpackList extends React.Component {

	constructor(props) {
		super(props);

		this.onPowerpackSelectionChanged = this.onPowerpackSelectionChanged.bind(this);
		this.noPowerpackSelected = this.noPowerpackSelected.bind(this);
	}
  
	onPowerpackSelectionChanged(powerpack) {
		this.props.onPowerpackSelectionToggled(powerpack);
	}
  
	noPowerpackSelected() {
		this.props.noPowerpackSelected();
	}

	allPowerPackItems(a, powerpacks, hasPowerpacks){
		return(
		<div>
			{powerpacks}
			<div className={hasPowerpacks == true ? "card card-bottom" : "d-none"} role="tab">
			<label className="radio-container" data-toggle="collapse" data-target="#pp-no">
				<input type="radio" name="radio" defaultChecked value="No thank you" onClick={() => a.noPowerpackSelected()} />
				<a>No thank you</a>
				<span className="radio-checkmark"></span>
			</label>
			<div id="pp-no" className="collapse" data-parent="#accordion"></div>
			</div>
		</div>
		)
	}
  
	render () {

		var a = this;

		var hideclass = (a.props.hide ? 'd-none' : '');

		var hasPowerpacks = a.props.powerpacks.length > 0;

		var powerpacks = a.props.powerpacks.map(function(powerpack){
			return <PowerpackItem 
						key={powerpack.Name} 
						onPowerpackSelectionToggled={powerpack => a.onPowerpackSelectionChanged(powerpack)}
						powerpack={powerpack} />;
		});

		return (
			<div className={'section-container text-container ' + hideclass}>
				<h4>Boost your hosting by adding a Powerpack.</h4>

				<p> We have designed a range of cost effective PowerPacks designed to boost your website’s availability at peak times. Increasing CPU and RAM provides an extra power boost at peak times, with the option to downgrade during quieter periods.</p>

                {
                    hasPowerpacks ?
                        <div id="powerpacks">
                            <div id="accordion" className="accordion">
                                {a.allPowerPackItems(a, powerpacks, hasPowerpacks)}
                            </div>
                        </div> :
                        <div className="col loading-container">
                            <span>Searching for powerpack options</span>
                            <img className="spinner" src="/content/images/loading.gif" height="30" width="30" alt="Searching for available powerpack options" />
                        </div>

                }
			</div>
		);
	}
}

export default PowerpackList


// WEBPACK FOOTER //
// ./Scripts/App/Hosting/Components/PowerpackList.es6